import React from "react";
import Icon from "@material-ui/core/Icon";
import "./footer.css";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";

const Footer = () => {
  return (
    <footer>
      <SlowMotionVideoIcon />
      <br />
      marianopuglisi.com {new Date().getFullYear()}
      <br />
      <br />
      El contenido de los cursos es propiedad de Mariano Puglisi y &nbsp;
      <a href="https://marianopuglisi.com">https://marianopuglisi.com</a>
      <br />
      No está permitida su reproducción total o parcial salvo expresa
      autorización del autor.
    </footer>
  );
};

export default Footer;
